import {SearchType} from './constants';
import type {SearchCriteriaRaw} from '../types';

import {rawAdvancedRawCriteriaToRuleObject} from './advancedRaw/utils/rawAdvancedRawCriteriaToRuleObject';
import {rawAttributeHistoryCriteriaToRuleObject} from './attributeHistory/utils/rawAttributeHistoryCriteriaToRuleObject';
import {rawCartCriteriaToRuleObject} from './cart/utils/rawCartCriteriaToRuleObject';
import {rawCategoryIdCriteriaToRuleObject} from './categoryId/utils/rawCategoryIdCriteriaToRuleObject';
import {rawCheckoutsCriteriaToRuleObject} from './checkouts/utils/rawCheckoutsCriteriaToRuleObject';
import {rawContentsCriteriaToRuleObject} from './contents/utils/rawContentsCriteriaToRuleObject';
import {rawDateCriteriaToRuleObject} from './date/utils/rawDateCriteriaToRuleObject';
import {rawExpirationCriteriaToRuleObject} from './expiration/utils/rawExpirationCriteriaToRuleObject';
import {rawFileAspectCriteriaToRuleObject} from './fileAspect/utils/rawFileAspectCriteriaToRuleObject';
import {rawFileFormatCriteriaToRuleObject} from './fileFormat/utils/rawFileFormatCriteriaToRuleObject';
import {rawFileFormatFamilyCriteriaToRuleObject} from './fileFormatFamily/utils/rawFileFormatFamilyCriteriaToRuleObject';
import {rawFileSizeCriteriaToRuleObject} from './fileSize/utils/rawFileSizeCriteriaToRuleObject';
import {rawKeywordCriteriaToRuleObject} from './keyword/utils/rawKeywordCriteriaToRuleObject';
import {rawMetadataCriteriaToRuleObject} from './metadata/utils/rawMetadataCriteriaToRuleObject';
import {rawSavedSearchCriteriaToRuleObject} from './savedSearch/utils/rawSavedSearchCriteriaToRuleObject';
import {rawUserCriteriaToRuleObject} from './user/utils/rawUserCriteriaToRuleObject';
import {rawVisualCriteriaToRuleObject} from './visual/utils/rawVisualCriteriaToRuleObject';

export const RuleObjectFromRawCriteriaMap = <const>{
	[SearchType.ADVANCED_RAW]: rawAdvancedRawCriteriaToRuleObject,
	[SearchType.ATTRIBUTE_HISTORY]: rawAttributeHistoryCriteriaToRuleObject,
	[SearchType.CART]: rawCartCriteriaToRuleObject,
	[SearchType.CATEGORY_ID]: rawCategoryIdCriteriaToRuleObject,
	[SearchType.CHECKOUTS]: rawCheckoutsCriteriaToRuleObject,
	[SearchType.CONTENTS]: rawContentsCriteriaToRuleObject,
	[SearchType.DATE]: rawDateCriteriaToRuleObject,
	[SearchType.EXPIRE]: rawExpirationCriteriaToRuleObject,
	[SearchType.FILE_ASPECT]: rawFileAspectCriteriaToRuleObject,
	[SearchType.FILE_FORMAT]: rawFileFormatCriteriaToRuleObject,
	[SearchType.FILE_FORMAT_FAMILY]: rawFileFormatFamilyCriteriaToRuleObject,
	[SearchType.FILE_SIZE]: rawFileSizeCriteriaToRuleObject,
	[SearchType.KEYWORD]: rawKeywordCriteriaToRuleObject,
	[SearchType.METADATA]: rawMetadataCriteriaToRuleObject,
	[SearchType.SAVED_SEARCH]: rawSavedSearchCriteriaToRuleObject,
	[SearchType.USER]: rawUserCriteriaToRuleObject,
	[SearchType.VISUAL]: rawVisualCriteriaToRuleObject,
};

/**
 * Given saved search criteria, get back a legit rule object
 * @param rawCriteria saved search criteria
 * @returns
 */
export const getRuleObjectFromRawCriteria = (rawCriteria: SearchCriteriaRaw) =>
	RuleObjectFromRawCriteriaMap[rawCriteria.type]?.(
		rawCriteria as unknown as any,
	);

export default getRuleObjectFromRawCriteria;
